<template>
  <section class="page film" v-if="filmModel && filmModel.content">
    
    <img v-if="filmModel.use_image" class="film-image" :src="filmModel.image_link" :alt="filmModel.title + ' - screenshot'">
    <vimeo-player v-if="!filmModel.use_image && !filmModel.youtube_link" :video-id="filmModel.vimeo_link" player-width="640" player-height="360"></vimeo-player>

    <div v-if="filmModel.youtube_link && !filmModel.use_image" id="youtube-player">
      <iframe v-if="!filmModel.use_image && filmModel.youtube_link" :src="youtubeLink" style="border:0px #ffffff none; width: 100%; aspect-ratio: 16/9;" name="youtube-player" scrolling="no" frameborder="1" marginheight="0px" marginwidth="0px" height="360px" width="640px" allowfullscreen>
    </iframe>
    </div>

    <header class="film-header">
      <p class="text-uppercase">
        <span class="no">{{ paddedNumber }}</span>
        <span class="title">{{ filmModel.title }}</span>
        <span class="year">{{ filmModel.year }}</span>
      </p>
      <hr>
      <p class="excerpt">{{ filmModel.excerpt }}</p>
    </header>

    <div class="film-content" :class="{ hidden: !contentVisible }" v-html="filmModel.content">
    </div>
  </section>
  <section v-else>
    <!-- Loading... -->
  </section>
</template>

<script>
import titleMixin from '../../mixins/TitleMixin'
import { mapState } from 'vuex'
import { zeroPad } from '../../utils'
import _ from 'lodash'

export default {
  metaInfo () {
    return {
      title: this.filmModel ? this.filmModel.title : 'Loading...'
    }
  },
  computed: {
    youtubeLink () {
      return `https://www.youtube.com/embed/${this.filmModel.youtube_link}`
    },
    paddedNumber () {
      return zeroPad(this.filmModel.number, 2)
    },
    ...mapState({
      contentVisible(state) {
        return state.filmContentVisible
      },
      filmModel(state) {
        return state.films.find(i => i.slug === this.$route.params.slug)
      }
    })
  },
  serverPrefetch() {
    return this.loadFilm()
  },
  beforeMount() {
  },
  mounted() {
    if (!this.filmModel.content)
      this.loadFilm()
  },
  methods: {
    loadFilm () {
      return this.$store.dispatch('loadFilm', this.$route.params.slug).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
